import React from 'react'

// Full-page "no access" landing for the custom-extension approval link when the
// visiting user isn't the compliance form's registered contact (BTB-461 follow-up).
// Mounted by Packages::ModalsController via the modal.extension_approval hook —
// the registered contact is often a purchaser/agent with no BoardPackager account at
// all, so this guides them to sign up (or sign in with the right email) rather than
// leaving them at a bare Devise wall or a blank 403.
export default function ExtensionApprovalNoAccess() {
  return (
    <div className="extension-approval-no-access dome-d-flex dome-flex-column dome-gap24">
      <div className="dome-h2 dome-color-red-alert">application package access denied</div>
      <div className="dome-d-flex dome-flex-column dome-gap24 dome-color-dark-grey">
        <div className="dome-d-flex dome-flex-column dome-gap12">
          <div className="dome-p1">You do not have permission to view this application.</div>
          <div className="dome-p1">
            Contact property management or the application owner for more information.
          </div>
        </div>
        <div className="dome-d-flex dome-align-center dome-justify-start">
          <a href="/" className='dome-link dome-link-cancel dome-color-med-grey'> return to dashboard</a>
        </div>
      </div>
    </div>
  )
}
